import React, { useState } from 'react';
import { useAgentStore } from '../../../store/agentStore';
import { AgentProfilePopup } from '../profile/AgentProfilePopup';
import { motion } from 'framer-motion';

export function ChatAvatar() {
  const { currentAgent } = useAgentStore();
  const [showProfile, setShowProfile] = useState(false);
  
  return (
    <>
      <motion.div 
        className="relative"
        whileHover={{ scale: 1.05 }}
        whileTap={{ scale: 0.95 }}
      >
        <button 
          className="focus:outline-none"
          onClick={() => setShowProfile(true)}
          aria-label="View agent profile"
        >
          <div className="relative">
            <img
              src={currentAgent.avatarUrl}
              alt={currentAgent.name}
              className="w-10 h-10 rounded-full object-cover border-2 border-white cursor-pointer hover:opacity-90 transition-opacity shadow-md"
            />
            <div className="absolute bottom-0 right-0 w-3 h-3 bg-green-400 rounded-full border-2 border-white"></div>
          </div>
        </button>
      </motion.div>
      
      {showProfile && (
        <AgentProfilePopup 
          agent={currentAgent} 
          onClose={() => setShowProfile(false)} 
        />
      )}
    </>
  );
}